"use strict";

var USER_PRIVACY_STATUS_PRIVATE = 'PRIVATE';
var USER_PRIVACY_STATUS_PUBLIC = 'PUBLIC';
var ROLE_GUEST = 'guest';
var ROLE_USER = 'user';
var ROLE_OPEN_BLOG_WRITER = 'open-blog-writer';
var ROLE_WRITER = 'writer';
var ROLE_GUEST_WRITER = 'guest-writer';
var ROLE_EDITOR = 'editor';
var ROLE_OWNER = 'owner';
var ROLE_SERVICE = 'service';
var ALLOWED_BLOG_ROLES = [ROLE_GUEST, ROLE_USER, ROLE_OPEN_BLOG_WRITER, ROLE_WRITER, ROLE_GUEST_WRITER, ROLE_EDITOR, ROLE_OWNER, ROLE_SERVICE];
var RESOURCE_BLOG = 'blog';
var RESOURCE_CATEGORY = 'category';
var RESOURCE_POST = 'post';
var RESOURCE_COMMENT = 'comment';
var RESOURCE_MEMBER = 'member';
var RESOURCE_RCE_SETTINGS = 'rceSettings';
var RESOURCE_FILE = 'file';
var RESOURCE_TAG = 'tag';
module.exports = {
  USER_PRIVACY_STATUS_PRIVATE: USER_PRIVACY_STATUS_PRIVATE,
  USER_PRIVACY_STATUS_PUBLIC: USER_PRIVACY_STATUS_PUBLIC,
  ROLE_GUEST: ROLE_GUEST,
  ROLE_USER: ROLE_USER,
  ROLE_OPEN_BLOG_WRITER: ROLE_OPEN_BLOG_WRITER,
  ROLE_GUEST_WRITER: ROLE_GUEST_WRITER,
  ROLE_WRITER: ROLE_WRITER,
  ROLE_EDITOR: ROLE_EDITOR,
  ROLE_OWNER: ROLE_OWNER,
  ROLE_SERVICE: ROLE_SERVICE,
  ALLOWED_BLOG_ROLES: ALLOWED_BLOG_ROLES,
  RESOURCE_BLOG: RESOURCE_BLOG,
  RESOURCE_CATEGORY: RESOURCE_CATEGORY,
  RESOURCE_POST: RESOURCE_POST,
  RESOURCE_COMMENT: RESOURCE_COMMENT,
  RESOURCE_MEMBER: RESOURCE_MEMBER,
  RESOURCE_RCE_SETTINGS: RESOURCE_RCE_SETTINGS,
  RESOURCE_FILE: RESOURCE_FILE,
  RESOURCE_TAG: RESOURCE_TAG
};